import { Organization as TOrganization } from "../api/organization/Organization";

export const ORGANIZATION_TITLE_FIELD = "title";

export const OrganizationTitle = (record: TOrganization): string => {
  return record.title || record.id;
};
